<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      v-if="isOnMobile"
      class="item"
      effect="dark"
      content="Ez a bizonylat elérhető a képviselő mobilján"
      placement="top"
      v-can="'representativeplacement.view'"
    >
      <el-button
        size="mini"
        icon="el-icon-check"
        type="success"
        plain
        style="margin-left: 5px; cursor: help"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      content="Bizonylat leküldése a képviselőnek 5 napra"
      placement="top"
      v-can="'representativeplacement.view'"
      v-if="!isOnMobile"
    >
      <el-button
        size="mini"
        :loading="loading"
        icon="el-icon-plus"
        style="margin-left: 5px;"
        @click="sendReceipt"
      />
    </el-tooltip>
  </div>
</template>

<script>
  import moment from 'moment'
  import getEnv from '../../../config/env.js'

  export default {
    props: ['representativePlacement'],
    computed: {
      isOnMobile() {
        if (moment(this.representativePlacement.created_at).isAfter(moment((new Date()).setHours(0,0,0,0)).subtract(getEnv('RECEIPT_HISTORY_INTERVAL_DAYS'), 'days'))) {
          return true;
        }
        if (this.representativePlacement.is_available_on_mobile && moment(this.representativePlacement.available_until_on_mobile).isAfter(moment())) {
          return true;
        }
        return false;
      }
    },
    data() {
      return {
        loading: false,
        deleteConfirmVisible: false,
      };
    },
    methods: {
      async sendReceipt() {
        this.loading = true;
        try {
          await axios.post(`api/representative-receipts/send-mobile/placement/${this.representativePlacement.id}`)
          this.$store.dispatch('representativePlacement/fetchAll');
        } catch (e) {

        }
        this.loading = false;
      },
    }
  };
</script>
